import React from 'react'
import { useTranslation } from 'react-i18next'

import ContentTranslations from 'components/ContentTranslations'
import { TextEditor } from 'components/forms'


const ContentTranslationsPage = ({ id, itemId, data }) => {
	const [t] = useTranslation()
	return (<ContentTranslations id={itemId} disabled={!!data?.FA_ProductId} translationTypes={[{
		type: 'PRODUCT',
		label: t('product_section.fields.name'),
		value: data.name
	}, {
		type: 'PRODUCT_altName',
		label: t('product_section.fields.alt_name'),
		value: data.altName
	}, {
		type: 'PRODUCT_declaration',
		label: t('product_section.fields.declaration'),
		value: data.declaration,
		Component: TextEditor
	}]}/>)
}

export default ContentTranslationsPage


